import React, { Component } from "react";
import { StyleSheet } from 'aphrodite';
import Card from "../../Components/Card/bigCard";
import { Link } from 'react-router-dom'

class Transmition extends Component {
    render() {
        return <div className="content pt-6">
            <div className="container">
                <Card>
                    <div className="d-inline back">
                        <Link to='/' className="back-btn"><i className="fa fa-caret-left"></i> Volver a la Plataforma</Link>
                    </div>
                    <div style={{height:'500px',paddingLeft:'4rem',paddingRight:'4rem'}}>
                        <center>
                            <h4 className="pt-4 pb-4">Políticas de seguridad para la transmisión de datos de tarjetas</h4>
                        </center>
                        <p align="justify"><strong>Políticas de seguridad&nbsp; para la transmisión de datos de tarjetas.</strong></p>
                        <p align="justify">A través de nuestro portal no se guardan informaciones de tarjeta de créditos ni débitos de ninguno de los tarjetahabiente. Esta información, en ningún momento será retenida, divulgada o registrada en el portal&nbsp;www.LaFactoriaRD.com, si no que utiliza procesadores terceros de pago.</p>
                        <p align="justify">Las únicas informaciones que pasan hacia la plataforma tercera son los datos del propietario, correo electrónico y monto total del importe a pagar.</p>
                    </div>
                </Card>
            </div>
        </div>;
    }
}
const styles = StyleSheet.create({
    titleStyle: {
        fontSize: '1.4rem',
        fontWeight: '1'
    }
})
export default Transmition;



// WEBPACK FOOTER //
// ./src/Pages/Politics/Transmition.js